var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "span",
                      _vm._g({}, on),
                      [
                        _vm._t("default", [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g({ attrs: { icon: "" } }, on),
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                          )
                        ])
                      ],
                      2
                    )
                  ]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("settings.costCentre.form.title")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t("global.itemName"),
                          rules: [_vm.max25chars, _vm.required],
                          counter: ""
                        },
                        model: {
                          value: _vm.contextCostCentre.name,
                          callback: function($$v) {
                            _vm.$set(_vm.contextCostCentre, "name", $$v)
                          },
                          expression: "contextCostCentre.name"
                        }
                      }),
                      _c(
                        "v-radio-group",
                        {
                          attrs: { mandatory: true },
                          model: {
                            value: _vm.contextCostCentre.is_enabled,
                            callback: function($$v) {
                              _vm.$set(_vm.contextCostCentre, "is_enabled", $$v)
                            },
                            expression: "contextCostCentre.is_enabled"
                          }
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              label: _vm.$t(
                                "settings.costCentre.form.disabled"
                              ),
                              value: 0
                            }
                          }),
                          _c("v-radio", {
                            attrs: {
                              label: _vm.$t("settings.costCentre.form.enabled"),
                              value: 1
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled:
                          !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save($event)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }